// extracted by mini-css-extract-plugin
export default {"root":"UVatfArUYiELhJsBSqOS","wrapper":"mz904qICdoHlwPJlPKOm"};